import React, { useMemo } from 'react';
import { TextField, Box, Typography } from '@mui/material';
import styles from './index.module.scss';
import { DatePicker } from '../../DatePicker';
import MuiPhoneInput from '../../../mui/MuiPhoneInput';
import { Country } from '#types';
import { AddressFieldsProps } from '../../../mui/AddressFieldSet';

export type FinishUpProps = {
	weddingDate?: string | Date | null | undefined;
	setWeddingDate: React.Dispatch<
		React.SetStateAction<string | Date | undefined>
	>;
	weddingDateValidation?: string;
	venue?: string | null | undefined;
	setVenue: React.Dispatch<React.SetStateAction<string | undefined>>;
	venueValidation?: string;
	phone?: string | null | undefined;
	setPhone: React.Dispatch<React.SetStateAction<string | undefined>>;
	phoneValidation?: string;
	onValidate: () => void;
	address?: AddressFieldsProps['address'];
};

export const FinishUp: React.FC<FinishUpProps> = ( {
	address,
	weddingDate,
	setWeddingDate,
	weddingDateValidation,
	venue,
	setVenue,
	venueValidation,
	phone,
	setPhone,
	phoneValidation,
	onValidate,
} ) => {
	const phoneCountry = useMemo( () => {
		return address?.country === Country.CA ? 'ca' : 'us';
	}, [ address ] );
	return (
		<Box className={ styles.finishUpContainer }>
			<Typography variant='h1' component='h1'>
				Finish Up
			</Typography>
			<Box className={ styles.form }>
				<Box className={ styles.row }>
					<DatePicker
						label='Event Date'
						value={ weddingDate }
						onChange={ ( date ) => setWeddingDate( date || undefined ) }
						onAccept={ onValidate }
						slotProps={ {
							textField: {
								variant: 'standard',
								slotProps: { htmlInput: { 'data-cy': 'weddingDate' } },
								error: !!weddingDateValidation,
								onBlur: onValidate,
							},
						} }
						errorText={ weddingDateValidation }
					/>
					<TextField
						fullWidth
						variant='standard'
						label='Venue (Optional)'
						value={ venue }
						onChange={ ( e ) => setVenue( e.target.value ) }
						onBlur={ onValidate }
						error={ !!venueValidation }
						helperText={ venueValidation }
						slotProps={ { htmlInput: { 'data-cy': 'venue' } } }
					/>
				</Box>
				<Box className={ styles.row }>
					<MuiPhoneInput
						fullWidth
						variant='standard'
						label='Phone (Optional)'
						value={ phone || '' }
						onChange={ setPhone }
						onBlur={ onValidate }
						errorText={ phoneValidation }
						slotProps={ {
							htmlInput: {
								'data-cy': 'phone',
							},
						} }
						country={ phoneCountry }
					/>
				</Box>
			</Box>
		</Box>
	);
};
